import React from "react";
const Loading = () => {
  return (
    <>
      <div className="loadings"></div>
    </>
  );
};
export default Loading;
